export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "volume.worker.ba2e7e32aeabbdf3b2f2.bundle.worker.js");
}
